import { useMutation } from '@tanstack/react-query';
import { CreateBookingPayload } from 'types/BookingCreate';
import {
  BookingDetailResponse,
  UpdateDetailApiPayload,
} from 'types/BookingDetails';
import { IBookingUI } from 'types/BookingDetailsV1';
import { VehicleResponse } from 'types/products';
import { userAxiosInstance } from './axiosInstance';
import bookingAxiosApi from './bookingAxiosApi';

export const getVehicles = async (id: string): Promise<VehicleResponse> => {
  const { data } = await bookingAxiosApi.get<VehicleResponse>(
    `/booking/listing/${id}`
  );
  return data;
};

export const getBookingDetail = async (
  id: string,
  vId: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingAxiosApi.get<BookingDetailResponse>(
    `/booking/detail/${id}/${vId}`
  );
  return data;
};

export const getBookingCheckout = async (
  id: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingAxiosApi.get<BookingDetailResponse>(
    `/booking/checkout/${id}`
  );
  return data;
};

export const updateBookingAddons = async (
  payload: UpdateDetailApiPayload
): Promise<string> => {
  const { data } = await bookingAxiosApi.put('/booking/add-ons', payload);
  return data;
};

export const updateBookingWithPromoCode = async (
  id: string,
  code: string
): Promise<string> => {
  const { data } = await bookingAxiosApi.put(`/booking/offer`, {
    Id: id,
    Code: code,
  });
  return data;
};

export const getCheckoutBookingDetails = async (
  detailsId: string
): Promise<BookingDetailResponse> => {
  const { data } = await bookingAxiosApi.get(
    `/booking/checkout?id=${detailsId}`
  );
  return data;
};

export async function createBooking(payload: CreateBookingPayload) {
  const { data } = await bookingAxiosApi.put('/booking/create', payload);
  return data;
}

export const getBookingById = async (
  bookingId: string
): Promise<IBookingUI> => {
  if (bookingId) {
    const { data } = await bookingAxiosApi.get(
      `/booking/booking-confirmed/${bookingId}`
    );
    return data.data;
  } else {
    throw new Error('booking details not found');
  }
};

export const uploadDocuments = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await userAxiosInstance.post('/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const deleteDocument = async (id: number) => {
  return await userAxiosInstance.delete(`/delete-document/${id}`);
};

export const useUploadDocuments = () => {
  return useMutation({
    mutationFn: async (file: File) => {
      return uploadDocuments(file);
    },
    mutationKey: ['uploadDocument'],
  });
};

export const useDeleteDocument = () => {
  return useMutation({
    mutationFn: async (id: number) => deleteDocument(id),
    mutationKey: ['deleteDocument'],
  });
};
